import BaseEntity from './BaseEntity';
import { FloorPlanPdfModel } from './2d/floorPlanPdfModel';
import { ENTITY_RENDER_ORDER } from '../constant/entity';
import { EEntityType } from '../types';

export class FloorPlanPdfEntity extends BaseEntity<EEntityType.FloorPlan> {
  protected override _model2d: FloorPlanPdfModel;
  private _canvas: HTMLCanvasElement | null = null;
  private _factor: number = 1;
  private _floorPlanType = 'pdf';

  constructor() {
    super({ type: EEntityType.FloorPlan });
    this._model2d = new FloorPlanPdfModel();
    this._model2d.setDisplayOrder(ENTITY_RENDER_ORDER.floorPlan);
  }

  get floorPlanType() {
    return this._floorPlanType;
  }

  getVisible() {
    return this._visible;
  }

  setVisible(visible: boolean) {
    this._visible = visible;
    this._model2d.setVisible(visible);
  }

  setCanvas(canvas: HTMLCanvasElement, factor: number) {
    this._canvas = canvas;
    this._factor = factor;
  }

  async render() {
    await this._model2d.render(this._canvas, this._factor);
  }

  override dispose() {
    super.dispose();
    this._model2d.dispose();
    if (this._canvas) {
      this._canvas.width = 0;
      this._canvas.height = 0;
      this._canvas = null;
    }
    this._factor = 1;
  }
}
